import * as React from "react";
const SvgJourneyIcon = (props) => (
  <svg
    width={21}
    height={20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    {...props}
  >
    <g
      style={{
        mixBlendMode: "multiply",
      }}
    >
      <path
        d="M10.25 1.667a8.333 8.333 0 1 0 0 16.667 8.333 8.333 0 0 0 0-16.667Zm0 15a6.667 6.667 0 1 1 0-13.334 6.667 6.667 0 0 1 0 13.334Z"
        fill="#121212"
      />
      <path
        d="M10.533 6.209a1.417 1.417 0 0 0-1.541-.25 1.333 1.333 0 0 0-.834 1.233v5.617a1.334 1.334 0 0 0 .834 1.233c.18.082.376.125.575.125a1.45 1.45 0 0 0 .966-.375l3.05-2.808a1.335 1.335 0 0 0 0-1.967l-3.05-2.808Zm-.7 5.958V7.834L12.175 10l-2.342 2.166Z"
        fill="#000"
      />
    </g>
  </svg>
);
export default SvgJourneyIcon;
